require('../../fhApp/transformResource');

angular.module('app.shared.leagueLookIn.leagueLookInService', [
  'app.transformResource'
])
  .factory('app.shared.leagueLookIn.leagueLookInService', [
    '$http', 'app.transformResource', '$q',
    function ($http, transformResource, $q) {
      "use strict";

      let service;

      function parseDate(game) {
        let gameTime = moment(game.dtegametimefixed);

        if (moment.isMoment(gameTime)) {
          game.dtegametimefixed = gameTime.toDate();
        }
      }

      service = {
        retrieve: function (game_id) {
          let defer = $q.defer();

          if (game_id) {
            return $http({
              method: 'GET',
              url: window.location.api('games_live_lookin/game/' + game_id),
              timeout: defer.promise,
              transformResponse: transformResource.onResponse(function (data) {
                _.forEach(data.games, parseDate);

                data.games.sort((a,b) => {
                  return a.dtegametimefixed.getTime() - b.dtegametimefixed.getTime();
                });

                return data;
              })
            });
          }
          else {
            defer.reject({error: 'No league ID provided.'});
          }

          return defer.promise;
        }
      };
      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/leagueLookIn/leagueLookInService.js